<div class="standardpanel">
  <h3>Ricerca precedenti</h3>
  <app-ricerca-precedenti-core [disableSave]="true"></app-ricerca-precedenti-core>
</div>

<ng-template [ngIf]="praticaForm">
  <form aria-labelledby="dati-generali" [formGroup]="praticaForm" (ngSubmit)="create.emit();">
    <div class="content-page-wrapper">
      <div class="standardpanel">
        <div class="titleblock">
          <h3 id="dati-generali" class="title1level">Dati Generali</h3>
        </div>
        <div class="container_dati_generali">
          <!-- input text 3/3/3/3 col -->
          <div class="row">
  
            <div comboModInput class="col-sm-4" [labelInput]="'Tipo pratica'"
                 formControlName="tipoPratica" [submitPending] ="true"
                 [optionsCombo] ="tipiPraticaOptions" [labelOption]="'descrizione'"
                 [objectReference]="request.pratica.tipoPratica"
                 (onReturn)="request.pratica.tipoPratica = $event"></div>
  
            <div class="col-sm-4">
              <p>
                <label for="stato-prat-cr-dati-class-lbl">Stato</label> <input id="stato-prat-cr-dati-class-lbl" class="form-control" type="text"
                                            disabled=""
                                            [value]="request.pratica.stato ? request.pratica.stato.label : labelCreatoDaSistema">
              </p>
            </div>
  
            <div comboModInput class="col-sm-4"
                [labelInput] = "'Visibilit&agrave;'"
                formControlName = "tipoVisibilita"
                [labelOption] = "'label'"
                [submitPending]="tipiVisibilitaDisabled"
                [optionsCombo] = "tipiVisibilitaOptions"
                [noDefaultOption] = "true"
                [objectReference]="request.pratica.tipoVisibilita"
                [mandatory]="true"
                (onReturn)="request.pratica.tipoVisibilita = $event;
                praticaForm.controls['tipoVisibilita'].setValue($event) ">
            </div>
  
          </div>
          <div class="row">
            <div comboModInput class="col-sm-4"
              [labelInput] = "'Codice'"
              formControlName = "codice"
              [labelOption] = "'codice'"
              [optionsCombo] = "codiceOptions"
              [objectReference]="request.pratica.codice"
              [mandatory]="true"
              (onReturn)="request.pratica.codice = $event;
              praticaForm.controls['codice'].setValue($event)">
            </div>
          </div>
          <div class="row">
            <div textAreaInput class="col-sm-12" [labelInput]="'Oggetto'"
                 formControlName="oggetto" [(ngModel)]="request.pratica.oggetto"></div>
          </div>
          <div class="row">
            <div textAreaInput class="col-sm-12" [labelInput]="'Note'"
                 formControlName="note" [(ngModel)]="request.pratica.note"></div>
          </div>
        </div>
      </div>
      <div class="standardpanel">
        <div>
          <h3 class="title1level title-mb-10">Campi personalizzati</h3>
            <app-pratica-metadata-form [tipoPratica]="idTipoPratica" (metadataListChange)="onRetrieve($event)" (formChange)="isFormMetadataValid($event)"></app-pratica-metadata-form>
        </div>
      </div>
      <div class="standardpanel">
  
        <div class="titleblock">
          <h3 class="title1level">Classificazione</h3>
        </div>
        <div class="container_dati_generali">
          <ng-template
            [ngIf]="request.classificazione?.classificazioni.length > 0 || classificazioniCopyPratica.length > 0">
            <table class="table-striped table aggiunta_classificazione">
              <caption class="sr-only">Tabella classificazione</caption>
              <tbody>
              <tr>
                <th>Materia</th>
                <th>Oggetto</th>
                <th>Argomento</th>
                <th>Primaria</th>
                <th></th>
              </tr>
              <ng-template ngFor
                           let-classificazioneCopy [ngForOf]="classificazioniCopyPratica"
                           let-iClassCopy=index>
                <tr>
                  <td>{{classificazioneCopy.materia ? classificazioneCopy.materia.label
                      : ''}}</td>
                  <td>{{classificazioneCopy.oggetto ? classificazioneCopy.oggetto.label
                      : ''}}</td>
                  <td>{{classificazioneCopy.argomento ?
                      classificazioneCopy.argomento.label : ''}}</td>
                  <td>{{classificazioneCopy.isPrincipale ? 'Si' : 'No'}}</td>
                  <td>
                    <span class="glyphicon glyphicon-copy" title="Classificazione copiata da pratica precedente"></span>
                    <button role="button" class="btn-link" aria-label="rimuovi classificazione copiata da pratica" (click)="removeClassificazioneCopy(iClassCopy);">
                      <span class="glyphicon glyphicon-trash"></span>
                    </button>
                  </td>
                </tr>
              </ng-template>
              <ng-template ngFor
                           let-classificazione [ngForOf]="request.classificazione.classificazioni"
                           let-iClass=index>
                <tr>
                  <td>{{classificazione.materia ? classificazione.materia.label
                      : ''}}</td>
                  <td>{{classificazione.oggetto ? classificazione.oggetto.label
                      : ''}}</td>
                  <td>{{classificazione.argomento ?
                      classificazione.argomento.label : ''}}</td>
                  <td>{{classificazione.isPrincipale ? 'Si' : 'No'}}</td>
                  <td>
                    <button role="button" class="btn-link" aria-label="rimuovi classificazione" (click)="removeClassificazione(iClass);">
                      <span class="glyphicon glyphicon-trash"></span>
                    </button>
                  </td>
                </tr>
              </ng-template>
              </tbody>
            </table>
          </ng-template>
  
          <ng-template
            [ngIf]="request.classificazione?.classificazioni.length == 0">
            <p>Inserire una classificazione.</p>
          </ng-template>
          <ng-template [ngIf]="classificazioneForm">
            <form [formGroup]="classificazioneForm">
              <div class="row">
                <div comboModInput class="col-sm-3" [labelInput]="'Materia'"
                     formControlName="materia" [mandatory]="true"
                     [control]="classificazioneForm.controls['materia']"
                     (change)="setComboClassificazione($event,'materia',newClassificazione);"
                     [optionsCombo] ="materieOptions"
                     [objectReference]="newClassificazione.materia"
                     [ngModel]="newClassificazione.materia"
                     (onReturn)="newClassificazione.materia = $event"></div>
  
                <div comboModInput class="col-sm-3" [labelInput]="'Oggetto'"
                     formControlName="oggetto" [mandatory]="true"
                     [control]="classificazioneForm.controls['oggetto']"
                     [ngModel]="newClassificazione.oggetto"
                     (change)="setComboClassificazione($event,'oggetto',newClassificazione);"
                     [submitPending]="!newClassificazione.materia"
                     [optionsCombo] ="oggettiOptions"
                     [objectReference]="newClassificazione.oggetto"
                     (onReturn)="newClassificazione.oggetto = $event"></div>
  
                <div comboModInput class="col-sm-3" [labelInput]="'Argomento'"
                     formControlName="argomento"
                     (change)="setComboClassificazione($event,'argomento',newClassificazione);"
                     [submitPending]="!newClassificazione.oggetto || !newClassificazione.materia"
                     [optionsCombo] ="argomentiOptions"
                     [objectReference]="newClassificazione.argomento"
                     (onReturn)="newClassificazione.argomento = $event"></div>
  
                <div checkBoxRadio class="col-sm-3"
                     [labelInput]="'Primaria'" formControlName="isPrincipale"
                     idInput="isPrincipale"
                     [objectReference]="newClassificazione.isPrincipale"
                     (onReturn)="newClassificazione.isPrincipale = $event"></div>
              </div>
              <div class="row">
                <p class="col-sm-2 col-xs-offset-6 col-sm-offset-10">
                  <button (click)="addClassificazione(newClassificazione);"
                          [disabled]="(!newClassificazione.materia || !newClassificazione.oggetto) || isClassificazioneAlreadyPresent(newClassificazione)"
                          type="button" class="btn btn-primary btn-block">Aggiungi</button>
                </p>
              </div>
              <div class="row">
                <p class="col-md-12 mandatory">
                  <em>* Campi obbligatori</em>
                </p>
              </div>
  
            </form>
          </ng-template>
        </div>
      </div>
  
      <div class="standardpanel">
        <div class="row">
          <p class="col-sm-3 col-xs-3">
            <button type="button" class="btn btn-primary btn-block white" (click)="back.emit()">Annulla</button>
          </p>
          <p class="col-sm-3 col-xs-3">
            <button type="button" class="btn btn-outline-secondary btn-block"
                    (click)="resetForm()">Reset</button>
          </p>
          <p submitButton [disabled]="!praticaForm.valid || !metadataFormValid"
             class="col-sm-3 col-xs-6 col-sm-offset-3"
             [labelButton]="'Salva bozza e prosegui'"></p>
        </div>
      </div>
    </div>

  </form>
</ng-template>
